//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../axios-client';
import { getAxios, getBaseUrl } from './helpers';

/**
 * @param providerName (optional) 
 * @param providerKey (optional) 
 * @return OK
 */
export function permissionsGet(providerName?: string | undefined, providerKey?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.GetPermissionListResultDto> {
    let url_ = getBaseUrl() + "/api/permission-management/permissions?";
    if (providerName === null)
        throw new Error("The parameter 'providerName' cannot be null.");
    else if (providerName !== undefined)
        url_ += "providerName=" + encodeURIComponent("" + providerName) + "&";
    if (providerKey === null)
        throw new Error("The parameter 'providerKey' cannot be null.");
    else if (providerKey !== undefined)
        url_ += "providerKey=" + encodeURIComponent("" + providerKey) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigPermissionsGet,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigPermissionsGet?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPermissionsGet(_response);
    });
}

function processPermissionsGet(response: AxiosResponse): Promise<Types.GetPermissionListResultDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.GetPermissionListResultDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetPermissionListResultDto>(null as any);
}

/**
 * @param providerName (optional) 
 * @param providerKey (optional) 
 * @param body (optional) 
 * @return OK
 */
export function permissionsUpdate(providerName?: string | undefined, providerKey?: string | undefined, body?: Types.UpdatePermissionsDto | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/permission-management/permissions?";
    if (providerName === null)
        throw new Error("The parameter 'providerName' cannot be null.");
    else if (providerName !== undefined)
        url_ += "providerName=" + encodeURIComponent("" + providerName) + "&";
    if (providerKey === null)
        throw new Error("The parameter 'providerKey' cannot be null.");
    else if (providerKey !== undefined)
        url_ += "providerKey=" + encodeURIComponent("" + providerKey) + "&";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPermissionsUpdate,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigPermissionsUpdate?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPermissionsUpdate(_response);
    });
}

function processPermissionsUpdate(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status === 204) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * @param groupName (optional) 
 * @param providerName (optional) 
 * @param providerKey (optional) 
 * @return OK
 */
export function permissionsGetByGroup(groupName?: string | undefined, providerName?: string | undefined, providerKey?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.GetPermissionListResultDto> {
    let url_ = getBaseUrl() + "/api/permission-management/permissions/by-group?";
    if (groupName === null)
        throw new Error("The parameter 'groupName' cannot be null.");
    else if (groupName !== undefined)
        url_ += "groupName=" + encodeURIComponent("" + groupName) + "&";
    if (providerName === null)
        throw new Error("The parameter 'providerName' cannot be null.");
    else if (providerName !== undefined)
        url_ += "providerName=" + encodeURIComponent("" + providerName) + "&";
    if (providerKey === null)
        throw new Error("The parameter 'providerKey' cannot be null.");
    else if (providerKey !== undefined)
        url_ += "providerKey=" + encodeURIComponent("" + providerKey) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigPermissionsGetByGroup,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigPermissionsGetByGroup?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPermissionsGetByGroup(_response);
    });
}

function processPermissionsGetByGroup(response: AxiosResponse): Promise<Types.GetPermissionListResultDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.GetPermissionListResultDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetPermissionListResultDto>(null as any);
}

/**
 * @param resourceName (optional) 
 * @return OK
 */
export function permissionsGetResourceProviderKeyLookupServices(resourceName?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.GetResourceProviderListResultDto> {
    let url_ = getBaseUrl() + "/api/permission-management/permissions/resource-provider-key-lookup-services?";
    if (resourceName === null)
        throw new Error("The parameter 'resourceName' cannot be null.");
    else if (resourceName !== undefined)
        url_ += "resourceName=" + encodeURIComponent("" + resourceName) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigPermissionsGetResourceProviderKeyLookupServices,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigPermissionsGetResourceProviderKeyLookupServices?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPermissionsGetResourceProviderKeyLookupServices(_response);
    });
}

function processPermissionsGetResourceProviderKeyLookupServices(response: AxiosResponse): Promise<Types.GetResourceProviderListResultDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.GetResourceProviderListResultDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetResourceProviderListResultDto>(null as any);
}

/**
 * @param resourceName (optional) 
 * @param serviceName (optional) 
 * @param filter (optional) 
 * @param page (optional) 
 * @return OK
 */
export function permissionsSearchResourceProviderKey(resourceName?: string | undefined, serviceName?: string | undefined, filter?: string | undefined, page?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.SearchProviderKeyListResultDto> {
    let url_ = getBaseUrl() + "/api/permission-management/permissions/search-resource-provider-keys?";
    if (resourceName === null)
        throw new Error("The parameter 'resourceName' cannot be null.");
    else if (resourceName !== undefined)
        url_ += "resourceName=" + encodeURIComponent("" + resourceName) + "&";
    if (serviceName === null)
        throw new Error("The parameter 'serviceName' cannot be null.");
    else if (serviceName !== undefined)
        url_ += "serviceName=" + encodeURIComponent("" + serviceName) + "&";
    if (filter === null)
        throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
        url_ += "filter=" + encodeURIComponent("" + filter) + "&";
    if (page === null)
        throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
        url_ += "page=" + encodeURIComponent("" + page) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigPermissionsSearchResourceProviderKey,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigPermissionsSearchResourceProviderKey?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPermissionsSearchResourceProviderKey(_response);
    });
}

function processPermissionsSearchResourceProviderKey(response: AxiosResponse): Promise<Types.SearchProviderKeyListResultDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.SearchProviderKeyListResultDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SearchProviderKeyListResultDto>(null as any);
}

/**
 * @param resourceName (optional) 
 * @return OK
 */
export function permissionsGetResourceDefinitions(resourceName?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.GetResourcePermissionDefinitionListResultDto> {
    let url_ = getBaseUrl() + "/api/permission-management/permissions/resource-definitions?";
    if (resourceName === null)
        throw new Error("The parameter 'resourceName' cannot be null.");
    else if (resourceName !== undefined)
        url_ += "resourceName=" + encodeURIComponent("" + resourceName) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigPermissionsGetResourceDefinitions,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigPermissionsGetResourceDefinitions?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPermissionsGetResourceDefinitions(_response);
    });
}

function processPermissionsGetResourceDefinitions(response: AxiosResponse): Promise<Types.GetResourcePermissionDefinitionListResultDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.GetResourcePermissionDefinitionListResultDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetResourcePermissionDefinitionListResultDto>(null as any);
}

/**
 * @param resourceName (optional) 
 * @param resourceKey (optional) 
 * @return OK
 */
export function permissionsGetResource(resourceName?: string | undefined, resourceKey?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.GetResourcePermissionListResultDto> {
    let url_ = getBaseUrl() + "/api/permission-management/permissions/resource?";
    if (resourceName === null)
        throw new Error("The parameter 'resourceName' cannot be null.");
    else if (resourceName !== undefined)
        url_ += "resourceName=" + encodeURIComponent("" + resourceName) + "&";
    if (resourceKey === null)
        throw new Error("The parameter 'resourceKey' cannot be null.");
    else if (resourceKey !== undefined)
        url_ += "resourceKey=" + encodeURIComponent("" + resourceKey) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigPermissionsGetResource,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigPermissionsGetResource?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPermissionsGetResource(_response);
    });
}

function processPermissionsGetResource(response: AxiosResponse): Promise<Types.GetResourcePermissionListResultDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.GetResourcePermissionListResultDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetResourcePermissionListResultDto>(null as any);
}

/**
 * @param resourceName (optional) 
 * @param resourceKey (optional) 
 * @param body (optional) 
 * @return OK
 */
export function permissionsUpdateResource(resourceName?: string | undefined, resourceKey?: string | undefined, body?: Types.UpdateResourcePermissionsDto | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/permission-management/permissions/resource?";
    if (resourceName === null)
        throw new Error("The parameter 'resourceName' cannot be null.");
    else if (resourceName !== undefined)
        url_ += "resourceName=" + encodeURIComponent("" + resourceName) + "&";
    if (resourceKey === null)
        throw new Error("The parameter 'resourceKey' cannot be null.");
    else if (resourceKey !== undefined)
        url_ += "resourceKey=" + encodeURIComponent("" + resourceKey) + "&";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPermissionsUpdateResource,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigPermissionsUpdateResource?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPermissionsUpdateResource(_response);
    });
}

function processPermissionsUpdateResource(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status === 204) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * @param resourceName (optional) 
 * @param resourceKey (optional) 
 * @param providerName (optional) 
 * @param providerKey (optional) 
 * @return OK
 */
export function permissionsDeleteResource(resourceName?: string | undefined, resourceKey?: string | undefined, providerName?: string | undefined, providerKey?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/permission-management/permissions/resource?";
    if (resourceName === null)
        throw new Error("The parameter 'resourceName' cannot be null.");
    else if (resourceName !== undefined)
        url_ += "resourceName=" + encodeURIComponent("" + resourceName) + "&";
    if (resourceKey === null)
        throw new Error("The parameter 'resourceKey' cannot be null.");
    else if (resourceKey !== undefined)
        url_ += "resourceKey=" + encodeURIComponent("" + resourceKey) + "&";
    if (providerName === null)
        throw new Error("The parameter 'providerName' cannot be null.");
    else if (providerName !== undefined)
        url_ += "providerName=" + encodeURIComponent("" + providerName) + "&";
    if (providerKey === null)
        throw new Error("The parameter 'providerKey' cannot be null.");
    else if (providerKey !== undefined)
        url_ += "providerKey=" + encodeURIComponent("" + providerKey) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigPermissionsDeleteResource,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigPermissionsDeleteResource?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPermissionsDeleteResource(_response);
    });
}

function processPermissionsDeleteResource(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status === 204) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * @param resourceName (optional) 
 * @param resourceKey (optional) 
 * @param providerName (optional) 
 * @param providerKey (optional) 
 * @return OK
 */
export function permissionsGetResourceByProvider(resourceName?: string | undefined, resourceKey?: string | undefined, providerName?: string | undefined, providerKey?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.GetResourcePermissionWithProviderListResultDto> {
    let url_ = getBaseUrl() + "/api/permission-management/permissions/resource/by-provider?";
    if (resourceName === null)
        throw new Error("The parameter 'resourceName' cannot be null.");
    else if (resourceName !== undefined)
        url_ += "resourceName=" + encodeURIComponent("" + resourceName) + "&";
    if (resourceKey === null)
        throw new Error("The parameter 'resourceKey' cannot be null.");
    else if (resourceKey !== undefined)
        url_ += "resourceKey=" + encodeURIComponent("" + resourceKey) + "&";
    if (providerName === null)
        throw new Error("The parameter 'providerName' cannot be null.");
    else if (providerName !== undefined)
        url_ += "providerName=" + encodeURIComponent("" + providerName) + "&";
    if (providerKey === null)
        throw new Error("The parameter 'providerKey' cannot be null.");
    else if (providerKey !== undefined)
        url_ += "providerKey=" + encodeURIComponent("" + providerKey) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigPermissionsGetResourceByProvider,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigPermissionsGetResourceByProvider?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPermissionsGetResourceByProvider(_response);
    });
}

function processPermissionsGetResourceByProvider(response: AxiosResponse): Promise<Types.GetResourcePermissionWithProviderListResultDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.GetResourcePermissionWithProviderListResultDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetResourcePermissionWithProviderListResultDto>(null as any);
}
let _requestConfigPermissionsGet: Partial<AxiosRequestConfig> | null;
export function getPermissionsGetRequestConfig() {
  return _requestConfigPermissionsGet;
}
export function setPermissionsGetRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPermissionsGet = value;
}
export function patchPermissionsGetRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPermissionsGet = patch(_requestConfigPermissionsGet ?? {});
}

let _requestConfigPermissionsUpdate: Partial<AxiosRequestConfig> | null;
export function getPermissionsUpdateRequestConfig() {
  return _requestConfigPermissionsUpdate;
}
export function setPermissionsUpdateRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPermissionsUpdate = value;
}
export function patchPermissionsUpdateRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPermissionsUpdate = patch(_requestConfigPermissionsUpdate ?? {});
}

let _requestConfigPermissionsGetByGroup: Partial<AxiosRequestConfig> | null;
export function getPermissionsGetByGroupRequestConfig() {
  return _requestConfigPermissionsGetByGroup;
}
export function setPermissionsGetByGroupRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPermissionsGetByGroup = value;
}
export function patchPermissionsGetByGroupRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPermissionsGetByGroup = patch(_requestConfigPermissionsGetByGroup ?? {});
}

let _requestConfigPermissionsGetResourceProviderKeyLookupServices: Partial<AxiosRequestConfig> | null;
export function getPermissionsGetResourceProviderKeyLookupServicesRequestConfig() {
  return _requestConfigPermissionsGetResourceProviderKeyLookupServices;
}
export function setPermissionsGetResourceProviderKeyLookupServicesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPermissionsGetResourceProviderKeyLookupServices = value;
}
export function patchPermissionsGetResourceProviderKeyLookupServicesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPermissionsGetResourceProviderKeyLookupServices = patch(_requestConfigPermissionsGetResourceProviderKeyLookupServices ?? {});
}

let _requestConfigPermissionsSearchResourceProviderKey: Partial<AxiosRequestConfig> | null;
export function getPermissionsSearchResourceProviderKeyRequestConfig() {
  return _requestConfigPermissionsSearchResourceProviderKey;
}
export function setPermissionsSearchResourceProviderKeyRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPermissionsSearchResourceProviderKey = value;
}
export function patchPermissionsSearchResourceProviderKeyRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPermissionsSearchResourceProviderKey = patch(_requestConfigPermissionsSearchResourceProviderKey ?? {});
}

let _requestConfigPermissionsGetResourceDefinitions: Partial<AxiosRequestConfig> | null;
export function getPermissionsGetResourceDefinitionsRequestConfig() {
  return _requestConfigPermissionsGetResourceDefinitions;
}
export function setPermissionsGetResourceDefinitionsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPermissionsGetResourceDefinitions = value;
}
export function patchPermissionsGetResourceDefinitionsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPermissionsGetResourceDefinitions = patch(_requestConfigPermissionsGetResourceDefinitions ?? {});
}

let _requestConfigPermissionsGetResource: Partial<AxiosRequestConfig> | null;
export function getPermissionsGetResourceRequestConfig() {
  return _requestConfigPermissionsGetResource;
}
export function setPermissionsGetResourceRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPermissionsGetResource = value;
}
export function patchPermissionsGetResourceRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPermissionsGetResource = patch(_requestConfigPermissionsGetResource ?? {});
}

let _requestConfigPermissionsUpdateResource: Partial<AxiosRequestConfig> | null;
export function getPermissionsUpdateResourceRequestConfig() {
  return _requestConfigPermissionsUpdateResource;
}
export function setPermissionsUpdateResourceRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPermissionsUpdateResource = value;
}
export function patchPermissionsUpdateResourceRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPermissionsUpdateResource = patch(_requestConfigPermissionsUpdateResource ?? {});
}

let _requestConfigPermissionsDeleteResource: Partial<AxiosRequestConfig> | null;
export function getPermissionsDeleteResourceRequestConfig() {
  return _requestConfigPermissionsDeleteResource;
}
export function setPermissionsDeleteResourceRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPermissionsDeleteResource = value;
}
export function patchPermissionsDeleteResourceRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPermissionsDeleteResource = patch(_requestConfigPermissionsDeleteResource ?? {});
}

let _requestConfigPermissionsGetResourceByProvider: Partial<AxiosRequestConfig> | null;
export function getPermissionsGetResourceByProviderRequestConfig() {
  return _requestConfigPermissionsGetResourceByProvider;
}
export function setPermissionsGetResourceByProviderRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPermissionsGetResourceByProvider = value;
}
export function patchPermissionsGetResourceByProviderRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPermissionsGetResourceByProvider = patch(_requestConfigPermissionsGetResourceByProvider ?? {});
}